<template>
  <div id="wrapper">
    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <h3 class="font-light m-b-xs">
            Let's start
          </h3>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="row text-center" style="margin-top: 50px">
        <div class="col-xs-12">
          <h1 class="text-uppercase">Let's Start</h1>
          <h5 class="m-t-md" style="margin-top: 30px">You can consult our <a target="_blank" href="https://www.idexlab.com/open-innovation-academy/">help-center</a> or register to our <a target="_blank" href="https://www.idexlab.com/webinar-idexlab-platform-demo">webinars</a></h5>

          <h4 style="margin-top: 75px">Select your use case</h4>
        </div>
      </div>
      <div class="row text-center" style="margin-top: 30px">
        <div class="col-md-6 col-lg-3 m-t-lg">
          <div class="hpanel">
            <div class="panel-body">
              <router-link class="btn btn-info" style="min-width: 200px; font-size: 0.9em" :to="{name: 'Profile'}">Promote your experience</router-link>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 m-t-lg">
          <div class="hpanel">
            <div class="panel-body">
              <router-link class="btn btn-info" style="min-width: 200px; font-size: 0.9em" :to="{name: 'SearchSimple'}" v-if="$user.isBasic()">Explore technology and science</router-link>
              <router-link class="btn btn-info" style="min-width: 200px; font-size: 0.9em" :to="{name: 'Search'}" v-else>Explore technology and science</router-link>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 m-t-lg">
          <div class="hpanel">
            <div class="panel-body">
              <button class="btn btn-info" style="min-width: 200px; font-size: 0.9em" @click="action = 'pinpoint' ">Pinpoint leading-edge experts</button>
              <pinpoint-experts v-if="action === 'pinpoint'" @onClose="action = null"></pinpoint-experts>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 m-t-lg">
          <div class="hpanel">
            <div class="panel-body">
              <button class="btn btn-info" style="min-width: 200px; font-size: 0.9em" @click="action = 'monitor' && $refs.editFollowedSearch.openModal()">Monitor keywords & experts</button>
              <edit-followed-search ref="editFollowedSearch" @onClose="action = null" ></edit-followed-search>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
body.light-skin .hpanel>.panel-footer, body.light-skin .hpanel>.panel-section {
  border: 1px solid #eaeaea;
  border-top: 0;
}
.hpanel.stats .list-group-item {
  padding:7px 15px;
}
</style>

<script>
import LimitPlan from '../../components/LimitPlan'
import PinpointExperts from '../../components/search/PinpointExperts'
import EditFollowedSearch from '../../components/modal/EditFollowedSearch'

export default {
  name: 'Start',
  components: {EditFollowedSearch, PinpointExperts, LimitPlan},
  data () {
    return {
      action: null
    }
  },
  methods: {
  },
  mounted () {
    let action = typeof this.$route.query.action !== 'undefined' ? this.$route.query.action : null
    let query = typeof this.$route.query.query !== 'undefined' ? this.$route.query.query : ''
    if (action !== null) {
      this.action = action
      switch (action) {
        case 'monitor':
          let followedSearch = {
            search_type: 0,
            frequency: '3_MONTH',
            search_terms: {
              term: query
            }
          }
          this.$refs.editFollowedSearch.setFollowedSearch(followedSearch)
          this.$refs.editFollowedSearch.openModal()
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/Start.vue